import api from "./api.js";

export default class LimitedMemberApi {
  static async create(data) {
    return await api.post(`api/limited-member`, data);
  }

  static async getList(data) {
    return await api.get(`api/limited-member`, data);
  }

  static async delete(data) {
    return await api.del(`api/limited-member`, data);
  }

  static async getById(id) {
    return await api.get(`api/limited-member/${id}`);
  }

  static async update(id, data) {
    return await api.patch(`api/limited-member/${id}`, data);
  }
}
